// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container__3gmdZ","link":"Breadcrumbs_link__1xERW"};